import { atom } from 'jotai';

export interface ShipToLocation {
  shipTo: string;
  name: string;
  address?: string;
}

export interface ShipToLocations {
  locations: ShipToLocation[];
}

export const shipToLocationsAtom = atom<ShipToLocations | null>(null);

export const selectedShipToAtom = atom<string | null>(null);
